import { Box } from '@mui/material';
// import HeaderNotifications from './Notifications';
import LanguageSwitcher from './LanguageSwitcher';
// import Chat from './Chat';
// import HeartBeat from './HeartBeat';

function HeaderButtons() {
  return (
    <Box>
      {/* <HeartBeat /> */}
      {/* <HeaderNotifications /> */}
      <LanguageSwitcher />
      {/* <Chat /> */}
    </Box>
  );
}

export default HeaderButtons;

